module.exports = __webpack_public_path__ + "static/media/flower-daffodil.d1b08f96.svg";